/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import owlCarousel from '../vendors/owl.carousel.min';


	//Custom Seclect Box
	if($('.custom-select-box').length){
		$('.custom-select-box').selectmenu().selectmenu('menuWidget').addClass('overflow');
	}

	//Datepicker
	if($('.datepicker').length) {
		$('.datepicker').datepicker();
	}

	jQuery(document).on('click', '.rental-heart, .property-wish, .gallery-heart', function () {
		jQuery(this).toggleClass('active');
	});

	// Listing single — Share (Web Share API, fallback copy link).
	jQuery(document).on('click', '.property-share', function (event) {
		event.preventDefault();
		event.stopPropagation();
		const $btn = jQuery(this);
		const url = String($btn.attr('data-share-url') || window.location.href);
		const title = String($btn.attr('data-share-title') || document.title);
		const $label = $btn.find('.property-share-label');
		const originalLabel = ($label.length ? $label.text() : 'Share') || 'Share';

		function flashLabel(text) {
			if (!$label.length) {
				return;
			}
			$label.text(text);
			window.clearTimeout($btn.data('shareFlashTimer'));
			$btn.data(
				'shareFlashTimer',
				window.setTimeout(function () {
					$label.text(originalLabel);
				}, 2000)
			);
		}

		function showCopyPopover() {
			jQuery('.property-share-popover').remove();
			const $pop = jQuery(
				'<div class="property-share-popover" role="dialog" aria-label="Copy listing link">' +
					'<input type="text" readonly class="property-share-popover-input" />' +
					'<button type="button" class="property-share-popover-copy">Copy</button>' +
					'<button type="button" class="property-share-popover-close" aria-label="Close">&times;</button>' +
				'</div>'
			);
			const $input = $pop.find('.property-share-popover-input');
			$input.val(url);
			$btn.after($pop);
			$input.trigger('focus').trigger('select');

			$pop.on('click', '.property-share-popover-copy', function (e) {
				e.preventDefault();
				$input.trigger('focus').trigger('select');
				let ok = false;
				try {
					ok = document.execCommand('copy');
				} catch (err) {
					ok = false;
				}
				if (!ok && navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(url).then(function () {
						flashLabel('Link copied');
						$pop.remove();
					}).catch(function () {
						flashLabel('Select & copy');
					});
					return;
				}
				flashLabel(ok ? 'Link copied' : 'Select & copy');
				if (ok) {
					$pop.remove();
				}
			});

			$pop.on('click', '.property-share-popover-close', function (e) {
				e.preventDefault();
				$pop.remove();
			});

			jQuery(document)
				.off('mousedown.propertySharePop')
				.on('mousedown.propertySharePop', function (e) {
					if (!jQuery(e.target).closest('.property-share-popover, .property-share').length) {
						$pop.remove();
						jQuery(document).off('mousedown.propertySharePop');
					}
				});
		}

		function copyWithInput() {
			const input = document.createElement('textarea');
			input.value = url;
			input.setAttribute('readonly', '');
			input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
			document.body.appendChild(input);
			input.focus();
			input.select();
			input.setSelectionRange(0, input.value.length);
			let ok = false;
			try {
				ok = document.execCommand('copy');
			} catch (e) {
				ok = false;
			}
			document.body.removeChild(input);
			if (ok) {
				flashLabel('Link copied');
				return;
			}
			showCopyPopover();
			flashLabel('Copy link');
		}

		function copyFallback() {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(url).then(function () {
					flashLabel('Link copied');
				}).catch(copyWithInput);
				return;
			}
			copyWithInput();
		}

		if (typeof navigator.share === 'function') {
			navigator
				.share({ title: title, text: title, url: url })
				.catch(function (err) {
					if (err && err.name === 'AbortError') {
						return;
					}
					copyFallback();
				});
			return;
		}

		copyFallback();
	});

	jQuery(function () {
		const gallery = jQuery('.property-gallery');

		if (!gallery.length) {
			return;
		}

		const slides = gallery.find('.gallery-slide');
		const thumbs = gallery.find('.gallery-thumb');
		const count = gallery.find('.gallery-count');
		let current = 0;

		function pauseVideos() {
			slides.find('video').each(function () {
				this.pause();
			});
			slides.find('iframe').removeAttr('src');
			slides.removeClass('is-playing');
		}

		function showSlide(index) {
			if (index < 0) {
				index = slides.length - 1;
			}
			if (index >= slides.length) {
				index = 0;
			}

			pauseVideos();
			current = index;
			const activeSlide = slides.removeClass('is-active').eq(current).addClass('is-active');
			const iframe = activeSlide.find('iframe[data-src]');
			iframe.attr('src', iframe.data('src'));
			thumbs.removeClass('is-active').eq(current).addClass('is-active');
			count.text((current + 1) + '/' + slides.length);
		}

		gallery.on('click', '.gallery-prev', function () {
			showSlide(current - 1);
		});

		gallery.on('click', '.gallery-next', function () {
			showSlide(current + 1);
		});

		gallery.on('click', '.gallery-thumb', function () {
			showSlide(jQuery(this).index());
		});

		gallery.on('click', '.slide-play', function (event) {
			event.preventDefault();
			const slide = jQuery(this).closest('.gallery-slide');
			const video = slide.find('video').get(0);
			const source = slide.data('video');

			if (!video || !source) {
				return;
			}

			if (!video.getAttribute('src')) {
				video.setAttribute('src', source);
			}

			const playAttempt = video.play();

			if (playAttempt && playAttempt.then) {
				playAttempt.then(function () {
					slide.addClass('is-playing');
				}).catch(function () {
					slide.removeClass('is-playing');
				});
			}
		});

		if (slides.length) {
			showSlide(0);
		}

		slides.find('video').on('ended', function () {
			jQuery(this).closest('.gallery-slide').removeClass('is-playing');
		});

		let startX = 0;

		gallery.find('.gallery-stage').on('touchstart', function (event) {
			startX = event.originalEvent.touches[0].clientX;
		});

		gallery.find('.gallery-stage').on('touchend', function (event) {
			const diff = event.originalEvent.changedTouches[0].clientX - startX;

			if (diff > 40) {
				showSlide(current - 1);
			} else if (diff < -40) {
				showSlide(current + 1);
			}
		});
	});






jQuery(function ($) {
    const gallery = $('.property-gallery');
    if (!gallery.length) return;

    const thumbContainer = gallery.find('.gallery-thumb').first().parent();
    if (!thumbContainer.length) return;

    // Active thumbnail ko center mein lane ka foolproof function
    function scrollActiveThumbIntoView() {
        const activeThumb = gallery.find('.gallery-thumb.is-active');
        if (!activeThumb.length) return;

        const container = thumbContainer[0];
        const thumb = activeThumb[0];

        // Exact position calculation using getBoundingClientRect (bina kisi offset error ke)
        const containerRect = container.getBoundingClientRect();
        const thumbRect = thumb.getBoundingClientRect();

        // Container ke andar thumb ki real position nikalna
        const thumbLeftInContainer = container.scrollLeft + (thumbRect.left - containerRect.left);

        // Center me adjust karna
        let scrollLeft = thumbLeftInContainer - (container.clientWidth / 2) + (thumb.offsetWidth / 2);

        // Bounds checking (Start ya End par cut hone se bachane ke liye)
        if (scrollLeft < 0) {
            scrollLeft = 0;
        }
        const maxScroll = container.scrollWidth - container.clientWidth;
        if (scrollLeft > maxScroll) {
            scrollLeft = maxScroll;
        }

        $(container).animate({
            scrollLeft: scrollLeft
        }, 300);
    }

    // MutationObserver se check karein jab bhi active class change ho
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class' && 
                $(mutation.target).hasClass('gallery-thumb') && 
                $(mutation.target).hasClass('is-active')) {
                scrollActiveThumbIntoView();
            }
        });
    });

    gallery.find('.gallery-thumb').each(function () {
        observer.observe(this, { attributes: true });
    });

    // Pehli load par bhi check karein
    setTimeout(scrollActiveThumbIntoView, 150);

    // Mouse Drag to Scroll (Desktop & Laptop ke liye)
    let isDown = false;
    let startX, scrollLeft;

    thumbContainer.on('mousedown', function (e) {
        isDown = true;
        $(this).addClass('is-dragging');
        startX = e.pageX - this.offsetLeft;
        scrollLeft = this.scrollLeft;
    });

    $(window).on('mouseup mouseleave', function () {
        isDown = false;
        thumbContainer.removeClass('is-dragging');
    });

    thumbContainer.on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.offsetLeft;
        const walk = (x - startX) * 1.5;
        this.scrollLeft = scrollLeft - walk;
    });
});


jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( function() {
	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if ( jQuery( '.header-wrapper' ).length > 0 ) {
		function updateHeaderHeight() {
			jQuery( '.header-wrapper' ).each( function() {
				jQuery( this ).css( '--btr_header-wrapper-default', jQuery( this ).outerHeight() + 'px' );
			} );
		}
		updateHeaderHeight();
		jQuery( window ).resize( updateHeaderHeight );
	}

	/**
	 * Toggle menu for mobile
	 */
	const navOverlay = jQuery( '.nav-overlay' );
	const htmlBody = jQuery( 'html, body' );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		navOverlay.toggleClass( 'open' );
		htmlBody.toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( '.menu-item-has-children > a:first-child' ).each( function() {
		jQuery( this ).after( '<span class="submenu-icon"></span>' );
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav' ).on( 'click', '.submenu-icon', function() {
		const parentLi = jQuery( this ).closest( 'li' );

		parentLi.siblings( '.active' )
			.removeClass( 'active' )
			.find( 'ul' ).slideUp();

		parentLi.toggleClass( 'active' ).find( 'ul' ).stop( true, true ).slideToggle();
		parentLi.parents( 'ul' ).toggleClass( 'disabled-menu', parentLi.hasClass( 'active' ) );
	} );

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */
	jQuery( '.menu-item-has-children > a' ).on( 'focus blur', function( event ) {
		jQuery( this ).siblings( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( '.sub-menu a, .mega-menu a' ).on( 'focus blur', function( event ) {
		jQuery( this ).closest( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	/**
	 * Script for Accessibility of html Tags
	 */
	jQuery( 'h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );
	jQuery( '.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li' ).each( function() {
		const link = jQuery( this ).find( 'a' );
		if ( link.length > 0 ) {
			jQuery( this ).removeAttr( 'tabindex' );
		} else {
			jQuery( this ).attr( 'tabindex', '0' );
		}
	} );
	jQuery( 'form p' ).each( function() {
		jQuery( this ).removeAttr( 'tabindex' );
	} );

	jQuery( 'a,button:not([href])' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	setTimeout( () => {
		jQuery( '#daextlwcnf-cookie-notice-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-notice-button-2' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-2' ).attr( 'role', 'button' );
	}, 500 );

	autosize();
	function autosize() {
		const text = jQuery( 'textarea' );

		text.each( function() {
			jQuery( this ).attr( 'rows', 5 );
			resize( jQuery( this ) );
		} );

		text.on( 'input', function() {
			resize( jQuery( this ) );
		} );

		function resize( $text ) {
			$text.css( 'min-height', 'auto' );
			$text.css( 'min-height', $text[ 0 ].scrollHeight + 'px' );
		}
	}
} );


// ====================================================================
// Slider JS 
// ====================================================================



jQuery(document).ready(function ($) {
    $('.neighborhoods').owlCarousel({
        loop: true,
        margin: 24,
        nav: true,
        dots:false,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 4
            }
        }
    });
});

jQuery(document).ready(function ($) {
    $('.says').owlCarousel({
        loop: true,
        margin: 24,
        nav: true,
        dots:false,
        autoplay: false,
        smartSpeed: 1000,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });
});


// ====================================================================
// Accordion JS 
// ====================================================================


(function () {
    document.querySelectorAll(".accordion-container").forEach(container => {
        const accordions = container.querySelectorAll(".accordions");

        if (accordions[0]) {
            accordions[0].classList.add("active");
            accordions[0].parentElement.classList.add("active"); // <-- parent main-acc pe bhi active
            accordions[0].nextElementSibling.style.maxHeight = accordions[0].nextElementSibling.scrollHeight + "px";
        }

        accordions.forEach(accordion => {
            accordion.addEventListener("click", () => {
                const isActive = accordion.classList.contains("active");

                accordions.forEach(acc => {
                    acc.classList.remove("active");
                    acc.parentElement.classList.remove("active"); // <-- parent se bhi remove
                    acc.nextElementSibling.style.maxHeight = null;
                });

                if (!isActive) {
                    accordion.classList.add("active");
                    accordion.parentElement.classList.add("active"); // <-- parent main-acc ko add
                    accordion.nextElementSibling.style.maxHeight = accordion.nextElementSibling.scrollHeight + "px";
                }
            });
        });
    });
})();





// ====================================================================
// MODEL JS 
// ====================================================================

function openModal(modalId) {
    // Guard: ignore empty or "#" which breaks jQuery selector
    if (!modalId || modalId === "" || modalId === "#") {
        return;
    }
    // Normalize: accept "myModal" or "#myModal"
    if (modalId.charAt(0) !== "#") {
        modalId = "#" + modalId;
    }
    var $modal = $(modalId);
    if ($modal.length === 0) {
        return; // Modal doesn't exist in DOM
    }
    var $content = $modal.find(".modal-contents");

    $modal.css({
        display: "block",
        overflowY: "auto"
    });

    var viewportHeight = $(window).height();
    var viewportWidth = $(window).width();
    var contentHeight = $content.outerHeight();
    var contentWidth = $content.outerWidth();

    var topPosition = contentHeight < viewportHeight
        ? (viewportHeight - contentHeight) / 2
        : 20;

    var leftPosition = (viewportWidth - contentWidth) / 2;

    $content.css({
        position: "absolute",
        top: "0px",
        left: leftPosition + "px",
        opacity: 0,
        maxHeight: "90vh",
        overflowY: "auto"
    });

    setTimeout(function () {
        $content.css({
            transition: "top 0.5s, opacity 0.5s",
            top: topPosition + "px",
            opacity: 1,
        });
    }, 10);
}


function closeModal(modalId) {
    var $modal = $("#" + modalId);
    var $content = $modal.find(".modal-contents");

    $content.css({
        transition: "top 0.5s, opacity 0.5s",
        opacity: 0,
        top: "0px",
    });

    setTimeout(function () {
        $modal.css("display", "none");
    }, 500);
}

$(document).ready(function () {

    $("a[href^='#']").on("click", function (event) {
        var href = $(this).attr("href") || "";
        // Ignore placeholder links like href="#"
        if (href === "#") {
            event.preventDefault();
            return;
        }
        
        // Only treat links as modals if the target modal actually exists
        if (href.charAt(0) === "#" && href.length > 1 && $(href).length) {
        event.preventDefault();
            openModal(href);
        }
    });

    $(window).on("click", function (event) {
        $(".styles-modal").each(function () {
            var $modal = $(this);
            if ($(event.target).is($modal)) {
                closeModal($modal.attr("id"));
            }
        });
    });
});

$(document).ready(function () {
    $(".close-btns").on("click", function () {
        var $modal = $(this).closest(".styles-modal");
        stopIframeVideo($modal);
    });

    $(window).on("click", function (event) {
        $(".styles-modal").each(function () {
            var $modal = $(this);
            if ($(event.target).is($modal)) {
                stopIframeVideo($modal);
            }
        });
    });

    function stopIframeVideo($modal) {
        $modal.find("iframe").each(function () {
            var $iframe = $(this);
            var src = $iframe.attr("src");
            $iframe.attr("src", "");
            setTimeout(function () {
                $iframe.attr("src", src);
            }, 500);
        });
    }
});


// ====================================================================
// CLOSE MODAL JS (SEPARATE)
// ====================================================================

$(document).ready(function () {

    $(".close-btns").on("click", function (e) {
        e.stopPropagation(); // window click conflict avoid

        var modalId = $(this).data("modal");
        closeModal(modalId);
    });

});




// ====================================================================
// LIGHTBOX JS 
// ====================================================================

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.portfolio-lightbox')) {
        const portfolioLightbox = GLightbox({
            selector: '.portfolio-lightbox'
        });
    }
});

